import { Role } from '@/model/role';
import type { RouteRecordRaw } from 'vue-router';
const Settings = () => import('@/components/vendors/VendorSettings.vue');
const VendorLegalInformationForm = () =>
  import('@/components/vendors/VendorLegalInformationForm.vue');
const VendorPublicInformationForm = () =>
  import('@/components/vendors/VendorPublicInformationForm.vue');
const VendorImagesForm = () =>
  import('@/components/vendors/VendorImagesForm.vue');
const VendorForm = () =>
  import('@/components/vendors/VendorBookingSettingsForm.vue');
const VendorFidelityForm = () =>
  import('@/components/vendors/VendorFidelityForm.vue');
const VendorIntegrationsForm = () =>
  import('@/components/vendors/VendorIntegrationsForm.vue');

const vendorsRoutes: RouteRecordRaw[] = [
  {
    path: '/settings',
    name: 'Settings',
    component: Settings,
    meta: {
      role: Role.ADMIN,
    },
    children: [
      {
        path: 'general',
        name: 'VendorLegalInformationForm',
        component: VendorLegalInformationForm,
        meta: {
          role: Role.ADMIN,
        },
        props: {
          formVendorSignUp: false,
        },
      },
      {
        path: 'public',
        name: 'VendorPublicInformationForm',
        component: VendorPublicInformationForm,
        meta: {
          role: Role.ADMIN,
        },
        props: {
          withStepButtons: false,
        },
      },
      {
        path: 'images',
        name: 'VendorImagesForm',
        component: VendorImagesForm,
        meta: {
          role: Role.ADMIN,
        },
      },
      {
        path: 'bookings',
        name: 'VendorForm',
        component: VendorForm,
        meta: {
          role: Role.ADMIN,
        },
        props: {
          vendorSignUpFinalStep: false,
        },
      },
      {
        path: 'fidelity',
        name: 'VendorFidelityForm',
        component: VendorFidelityForm,
        meta: {
          role: Role.ADMIN,
        },
      },
      {
        path: 'integrations',
        name: 'VendorIntegrationsForm',
        component: VendorIntegrationsForm,
        meta: {
          role: Role.ADMIN,
        },
      },
    ],
  },
];

export default vendorsRoutes;
